import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import SVGIcon from '../utils/SVGIcon';
import './ModulesSlider.css'; // Import your custom styles

const ModulesSlider = ({ slidesData }) => {
    const { t } = useTranslation();
    const modulesSliderContent = t(slidesData, { returnObjects: true });

    useEffect(() => {
        const swiperInstance = document.querySelector('.mySwiper')?.swiper;
        if (swiperInstance) {
            swiperInstance.params.navigation.prevEl = '.swiper-button-prev';
            swiperInstance.params.navigation.nextEl = '.swiper-button-next';
            swiperInstance.navigation.init();
            swiperInstance.navigation.update();
        }
    }, []);

    return (
        <div className="modules-slider-container">
            <Swiper
                spaceBetween={12}
                slidesPerView={1.1}
                breakpoints={{
                    480: { slidesPerView: 1.2 },
                    600: { slidesPerView: 1.5 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1280: { slidesPerView: 4 },
                    1536: { slidesPerView: 5 },
                }}
                mousewheel
                loop
                className="mySwiper"
                modules={[Navigation, Mousewheel]}
            >
                {modulesSliderContent.map(({ id, title, text, iconName }) => (
                    <SwiperSlide key={id}>
                        <div className="module-card">
                            <div className="module-card-content">
                                <SVGIcon iconName={iconName} className="module-icon" />
                                <h3 className="module-title">{title}</h3>
                                <p className="module-text">{text}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="navigation-buttons">
                <button className="nav-button swiper-button-prev">
                    <img src="/img/leftArrow.png" alt="Prev" />
                </button>
                <button className="nav-button swiper-button-next">
                    <img src="/img/rightArrow.png" alt="Next" />
                </button>
            </div>
        </div>
    );
};

export default ModulesSlider;
